// Tipi di dati
import {enel, plenitude, illumia, union} from '../assets/index';
export interface OffertaBase {
  id: string;
  titolo: string;
  descrizione: string;
  prezzo: number;
  unitaMisura: string;
  popolare?: boolean;
  caratteristiche: string[];
}

export interface Logo {
  id: string;
  nome: string;
  immagine: string;
  descrizione: string;
}

export interface OffertaLuce extends OffertaBase {
  tipo: 'luce';
}

export interface OffertaGas extends OffertaBase {
  tipo: 'gas';
}

export interface OffertaInternet extends OffertaBase {
  tipo: 'internet';
}

export type Offerta = OffertaLuce | OffertaGas | OffertaInternet;

export interface ServizioBusinessCard {
  id: string;
  icona: string;
  titolo: string;
  descrizione: string;
}

export interface MembroTeam {
  id: string;
  nome: string;
  ruolo: string;
  descrizione: string;
  foto?: string;
}

export interface ValoreAziendale {
  id: string;
  icona: string;
  titolo: string;
  descrizione: string;
}

// Dati delle offerte luce
export const offerteLuce: OffertaLuce[] = [
  {
    id: 'luce-base',
    tipo: 'luce',
    titolo: 'Piano Base',
    descrizione: 'Ideale per piccole abitazioni',
    prezzo: 0.14,
    unitaMisura: '/kWh',
    caratteristiche: [
      'Tariffa monoraria',
      'Prezzo bloccato per 12 mesi',
      'Attivazione gratuita',
      'Assistenza base'
    ]
  },
  {
    id: 'luce-famiglia',
    tipo: 'luce',
    titolo: 'Piano Famiglia',
    descrizione: 'Perfetto per famiglie',
    prezzo: 0.12,
    unitaMisura: '/kWh',
    popolare: true,
    caratteristiche: [
      'Tariffa bioraria',
      'Prezzo bloccato per 24 mesi',
      'Attivazione gratuita',
      'Assistenza prioritaria',
      'Energia 50% da fonti rinnovabili'
    ]
  },
  {
    id: 'luce-green',
    tipo: 'luce',
    titolo: 'Piano Green',
    descrizione: 'Per chi ama l\'ambiente',
    prezzo: 0.16,
    unitaMisura: '/kWh',
    caratteristiche: [
      'Tariffa monoraria',
      'Prezzo bloccato per 12 mesi',
      'Attivazione gratuita',
      'Assistenza prioritaria',
      'Energia 100% da fonti rinnovabili'
    ]
  }
];

// Dati delle offerte gas
export const offerteGas: OffertaGas[] = [
  {
    id: 'gas-base',
    tipo: 'gas',
    titolo: 'Gas Base',
    descrizione: 'Per piccoli consumi',
    prezzo: 0.45,
    unitaMisura: '/Smc',
    caratteristiche: [
      'Prezzo fisso',
      'Durata 12 mesi',
      'Attivazione gratuita',
      'Assistenza base'
    ]
  },
  {
    id: 'gas-famiglia',
    tipo: 'gas',
    titolo: 'Gas Famiglia',
    descrizione: 'Ideale per famiglie',
    prezzo: 0.42,
    unitaMisura: '/Smc',
    popolare: true,
    caratteristiche: [
      'Prezzo fisso',
      'Durata 24 mesi',
      'Attivazione gratuita',
      'Assistenza prioritaria',
      'Sconto 5% dal secondo anno'
    ]
  },
  {
    id: 'gas-inverno',
    tipo: 'gas',
    titolo: 'Gas Inverno',
    descrizione: 'Per grandi consumi',
    prezzo: 0.40,
    unitaMisura: '/Smc',
    caratteristiche: [
      'Prezzo fisso',
      'Durata 24 mesi',
      'Attivazione gratuita',
      'Assistenza prioritaria',
      'Sconto 10% nei mesi estivi'
    ]
  }
];

// Dati delle offerte internet
export const offerteInternet: OffertaInternet[] = [
  {
    id: 'internet-base',
    tipo: 'internet',
    titolo: 'Internet Base',
    descrizione: 'Per uso base',
    prezzo: 24.90,
    unitaMisura: '/mese',
    caratteristiche: [
      'ADSL fino a 20 Mbps',
      'Chiamate a consumo',
      'Modem incluso',
      'Attivazione 39€'
    ]
  },
  {
    id: 'internet-fibra',
    tipo: 'internet',
    titolo: 'Fibra Ultraveloce',
    descrizione: 'Per streaming e gaming',
    prezzo: 29.90,
    unitaMisura: '/mese',
    popolare: true,
    caratteristiche: [
      'Fibra fino a 1 Gbps',
      'Chiamate illimitate',
      'Modem Wi-Fi 6 incluso',
      'Attivazione gratuita',
      'Assistenza prioritaria'
    ]
  },
  {
    id: 'internet-premium',
    tipo: 'internet',
    titolo: 'Premium Business',
    descrizione: 'Per professionisti',
    prezzo: 39.90,
    unitaMisura: '/mese',
    caratteristiche: [
      'Fibra fino a 2,5 Gbps',
      'Chiamate illimitate',
      'Modem Wi-Fi 6 professionale',
      'IP statico',
      'Assistenza dedicata 24/7',
      'Attivazione gratuita'
    ]
  }
];

// Raggruppo tutte le offerte per un accesso più facile
export const offerte: {
  luce: OffertaLuce[];
  gas: OffertaGas[];
  internet: OffertaInternet[];
} = {
  luce: offerteLuce,
  gas: offerteGas,
  internet: offerteInternet
};

// Dati dei servizi business
export const serviziBusiness: ServizioBusinessCard[] = [
  {
    id: 'energia-business',
    icona: 'faLightbulb',
    titolo: 'Energia per Business',
    descrizione: 'Tariffe dedicate alle aziende con prezzi competitivi e possibilità di energia verde certificata.'
  },
  {
    id: 'gas-business',
    icona: 'faFireFlameCurved',
    titolo: 'Gas per Business',
    descrizione: 'Soluzioni per il riscaldamento e la produzione con tariffe vantaggiose per grandi consumi.'
  },
  {
    id: 'connettivita-business',
    icona: 'faWifi',
    titolo: 'Connettività Professionale',
    descrizione: 'Fibra dedicata, banda garantita e servizi cloud per la tua attività.'
  }
];


// Dati dei valori aziendali
export const valoriAziendali: ValoreAziendale[] = [
  {
    id: 'eccellenza',
    icona: 'faTrophy',
    titolo: 'Eccellenza',
    descrizione: 'Puntiamo sempre al massimo della qualità in ogni servizio che offriamo.'
  },
  {
    id: 'cliente',
    icona: 'faUsers',
    titolo: 'Cliente al Centro',
    descrizione: 'Ascoltiamo attentamente le esigenze dei nostri clienti per offrire soluzioni su misura.'
  },
  {
    id: 'trasparenza',
    icona: 'faHandshake',
    titolo: 'Trasparenza',
    descrizione: 'Comunichiamo in modo chiaro e sincero, senza costi nascosti o sorprese.'
  },
  {
    id: 'sostenibilita',
    icona: 'faLeaf',
    titolo: 'Sostenibilità',
    descrizione: 'Promuoviamo soluzioni energetiche sostenibili per un futuro migliore.'
  }
];

// Dati statistici dell'azienda
export const statisticheAzienda = {
  anniEsperienza: 10,
  clientiSoddisfatti: 15000,
  fornitoriPartner: 50,
  consulentiEsperti: 30
};

// Dati di contatto dell'azienda
export const contattiAzienda = {
  telefonoServizioClienti: '+390240055045',
  telefonoSupporto: '+390294753134',
  email: 'info@serviziobolletta.it',
  indirizzo: 'Via Filippo Argelati 10, Milano',
  orarioLavorativo: '9:00-19:00',
  orarioSabato: '9:00-14:00',
  orarioDomenica: 'Chiuso'
};

export const fornitori = [
  {
    id: 1,
    name: "Enel Energia",
    image: enel,
    alt: "Logo Enel Energia"
  },
  {
    id: 2,
    name: "Eni Plenitude",
    image: plenitude,
    alt: "Logo Eni Plenitude"
  },
  {
    id: 3,
    name: "Illumia",
    image: illumia,
    alt: "Logo Illumia"
  },
  {
    id: 4,
    name: "Union",
    image: union,
    alt: "Logo Union"
  },
]; 